export default {
	mounted (el, binding) {
        if(!el.querySelector('input')) return
		 el.querySelector('input').focus()
	}
}
